import React from 'react'
import { Tag } from 'element-react'

const TagSG = () => {
    return (
        <div>
            <Tag type="primary">Tag Default / Primary</Tag>
            <Tag type="secondary">Tag Secondary</Tag>
            <Tag type="success">Tag Success</Tag>
            <Tag type="warning">Tag Warning</Tag>
            <Tag type="danger">Tag Danger</Tag>
            <Tag type="info">Tag Info</Tag>
            <Tag type="gray">Tag Gray</Tag>
            <br />

            <Tag type="primary" className="hollow">
                Tag Default / Primary
            </Tag>
            <Tag type="secondary" className="hollow">
                Tag Secondary
            </Tag>
            <Tag type="success" className="hollow">
                Tag Success
            </Tag>
            <Tag type="warning" className="hollow">
                Tag Warning
            </Tag>
            <Tag type="danger" className="hollow">
                Tag Danger
            </Tag>
            <Tag type="info" className="hollow">
                Tag Info
            </Tag>
            <Tag type="gray" className="hollow">
                Tag Gray
            </Tag>
        </div>
    )
}

export default TagSG
